module.exports = __webpack_public_path__ + "img/pickup_driving.db17365f.svg";